import { applyMiddleware, combineReducers } from 'redux';
import { createStore } from 'redux';

import ReduxThunk from 'redux-thunk';
import CommonReducer from './store/reducers/CommonReducer';


const rootReducer = combineReducers({
    common:CommonReducer    
});


export const store = createStore(rootReducer,applyMiddleware(ReduxThunk));


